import { createFileRoute, Outlet } from '@tanstack/react-router';
import { DocumentPaymentSchedules } from '@/pages/document-payment-schedules';
import { commonSearchSchema } from '@/routes/-shared/commonSearchSchema';
import { RoleGuard } from '@/components/molecules/role-guard';
import { usePermissions } from '@/hooks/use-permissions';
import z from '@/lib/zod';
import {
  optionalSearchBoolean,
  optionalSearchString,
} from '@/lib/zod-search-params';
import { amountSearchParams } from '@/lib/filters/amount-search-params';

export const documentPaymentSchedulesSearchSchema = commonSearchSchema.extend({
  subTab: z.string().nullish(),
  direction: z.string().nullish(),
  isExpired: z.boolean().nullish(),
  toPay: z.boolean().nullish(),
  categoryIds: optionalSearchString(),
  dueDateFrom: optionalSearchString(),
  dueDateTo: optionalSearchString(),
  documentStatus: optionalSearchString(),
  reconciliationStatus: optionalSearchString(),
  sepa_payment: z.string().nullish(),
  /** Vista della collezione: assente = lista, 'calendar' = vista calendario. */
  view: z.string().nullish(),
  /**
   * Toggle "Includi bozze". Senza dichiararlo qui `validateSearch` lo
   * scartava dalla URL e il filtro si perdeva a ogni refresh. Booleano come
   * nel Forecast: le rotte condividono il tipo del parametro.
   */
  includeDrafts: optionalSearchBoolean(),
  excludeCardPaidPurchases: optionalSearchBoolean(),
  /** Pannello Filtri: importo (valore assoluto) e Stato (CSV). */
  ...amountSearchParams,
  statuses: optionalSearchString(),
});

export const Route = createFileRoute(
  '/protected/_layout/document-payment-schedules/_layout'
)({
  validateSearch: documentPaymentSchedulesSearchSchema,
  component: DocumentPaymentSchedulesLayout,
});

function DocumentPaymentSchedulesLayout() {
  const { canAccessPaymentSchedules, isLoading } = usePermissions();

  return (
    <RoleGuard hasAccess={canAccessPaymentSchedules} isLoading={isLoading}>
      <DocumentPaymentSchedules />
      <Outlet />
    </RoleGuard>
  );
}
